import type { UserRole } from '../../hooks/use-auth';
import type { SignupIntent } from './signup-intent';

/**
 * Destino pós-login da conta (T1.19b, gate D3 — ADR 0039).
 *
 * Decidido **por condição**, sem flag nova: o onboarding consumer grava `consumer_profiles` ao
 * concluir **ou** saltar, logo a linha já é o marcador de "visto"; o onboarding pro cria o negócio
 * na etapa 1, logo o negócio é o marcador dele. Uma flag seria um segundo estado a sincronizar.
 *
 * 🔴 `unknown` (leitura falhada) **nunca** redireciona: mandar alguém para o onboarding por uma
 * falha de rede é a mesma armadilha da T1.19, em que "leitura falhou" virava "não tem negócio".
 */

export type Presenca = 'none' | 'exists' | 'unknown';

export type EntryDestination = '/onboarding/consumer' | '/dashboard/onboarding';

export interface EntryState {
  role: UserRole | null;
  signupIntent: SignupIntent | null;
  business: Presenca;
  consumerProfile: Presenca;
}

export function resolveEntryDestination({
  role,
  signupIntent,
  business,
  consumerProfile,
}: EntryState): EntryDestination | null {
  // Só a conta `consumer` tem onboarding por fazer; os demais papéis já têm o seu lugar.
  if (role !== 'consumer') return null;

  // Com negócio (rascunho incluído), o `RequireBusinessContext` e o banner já conduzem a pessoa.
  if (business !== 'none') return null;

  // Entrada B: "segue imediatamente" para o onboarding profissional (PRD §5.0).
  if (signupIntent === 'professional_owner') return '/dashboard/onboarding';

  // Entrada A — e contas sem intenção gravada (anteriores à T1.19b), que são consumer por omissão.
  return consumerProfile === 'none' ? '/onboarding/consumer' : null;
}
